import React from 'react';
import classNames from 'classnames';
import translate from '../../locales';
import { useState } from 'react';
import { styleWithCommonClasses } from '../../_constants/emparkConstants';
import { Tab, Tabs, withStyles } from '@material-ui/core';
import RateMappingController from './RateMappingController';
import RuleMappingController from './RuleMappingController';


const __t = translate;

const styles = styleWithCommonClasses({
    paddingOnTop: {
        paddingTop: '20px'
    },
    upperCase: {
        textTransform: 'uppercase'
    },
    containerSelect: {
        width: '100%',
        padding: '4px'
    },
    errorBorder: {
        border: '1px solid red',
        borderRadius: '5px'
    },
})

const ParameterChildContainer = (props) => {
    const [child, setChild] = useState(0); // positions | groups | emission profiles

    if (props.showRules) {
        return (
            <div style={{ border: '1px solid #ccc' }}>
                <Tabs
                    className={classNames(props.classes.tabPanel)}
                    style={{ backgroundColor: 'white' }}
                    value={child}
                    onChange={(e, index) => setChild(index)}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    <Tab key="pt-1" className={classNames(props.classes.tab)} label={__t('rates')} disabled={props.childIsInView}></Tab>
                    <Tab key="pt-2" className={classNames(props.classes.nTab)} label={__t('rules')} disabled={props.childIsInView}></Tab>
                </Tabs>

                <div style={{ marginTop: '10px', paddingLeft: '15px', paddingRight: '15px', paddingBottom: '10px' }}>
                    {child == 0 ?
                        <div>
                            <RateMappingController
                                contextId={props.contextId}
                                parameterId={props.parameterId}
                                setMessage={props.setMessage}
                            />
                        </div>
                        :
                        <div>
                            <RuleMappingController
                                contextId={props.contextId}
                                parameterId={props.parameterId}
                                setMessage={props.setMessage}
                            />
                        </div>
                    }
                </div>
            </div>
        )
    }

    return (
        <div style={{ border: '1px solid #ccc', padding: '10px' }}>
            <RateMappingController
                contextId={props.contextId}
                parameterId={props.parameterId}
                setMessage={props.setMessage}
            />
        </div>
    )
}

export default withStyles(styles)(ParameterChildContainer);
